module.exports = __webpack_public_path__ + "img/laurent-pro.9a0bf3d8.jpg";